<!-- Using transclusion, text will be in here -->
<ng-container [ngSwitch]="hostLoading">
  <awair-loading-icon *ngSwitchCase="true"></awair-loading-icon>
  <ng-content *ngSwitchDefault></ng-content>
</ng-container>
